export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-6.fe030e10.svg";